import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import WorkPage from '../../components/WorkPage';
import { fetch_work } from '@store/works.slice';

const Work = () => {
  const { work } = useSelector((state) => state.works);
  const dispatch = useDispatch();

  const { work_slug } = useParams();
  useEffect(() => {
    console.log(work_slug);
    if (Object.keys(work).length === 0 && work.constructor === Object) {
      fetch(work_slug);
    }
  }, [work_slug]);

  const fetch = async (_work_slug) => {
    console.log(_work_slug);
    await dispatch(fetch_work(_work_slug));
  };

  const WorkComponent = useMemo(() => {
    if (!(Object.keys(work).length === 0 && work.constructor === Object)) {
      return (
        <WorkPage
          images={work.photo_gallery.images[0].concat(work.videos || [])}
          text={work}
        />
      );
    } else {
      return <> </>;
    }
  }, [work]);

  return <>{WorkComponent}</>;
};

export default Work;
